var exports = {};
exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};
export default exports;